import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { change, Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Col, Card, Button } from 'reactstrap';
import DataReactTable from '../Diagnostic/DataReactTable';
import ReactTableActionsDiagnostic from '../Diagnostic/ReactTableActionsDiagnostic';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import renderSelectField from '../../../../../shared/components/form/Select';
import ModalMessage from '../../../../../shared/components/Modal';

const renderField = ({
    input, placeholder, type, meta: { touched, error },
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);

renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};


class EventAdverse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            eventAdverse: "",
            description: "",
            openModal: false,
            dataDiagnostic: [],
            diagnostic: [],
            relationResearch: "",
            relationStuty: "",
            clasification: "",
            dateTeam: new Date(),
            dateEvent: new Date(),
            causality: "",
            typeReport: "",
            continuity: "",
            intensity: "",
            actionResearch: "",
            ciego: "",
            brazo: "",
            openAlert: false,
            modalAlert: { message: '', color: '', title: '' },
            errors: {}
        }
    }

    componentDidMount = () => {
        //this.verifyEventAdverse();
    }

    verifyEventAdverse = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + `evento-adverso/consultar?id_historia=${this.props.id_historia}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            return response.json();
        }).then(data => {
            if (data.existe) {
                console.log("dataEventAdverse",data);
                this.setState({
                    eventAdverse: data.evento_adverso
                },() => {
                    var { dispatch } = this.props;
                    dispatch(change("event-adverse-form", "event-adverse", this.state.eventAdverse));
                })
            }
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    handlerEventAdverse = (eventAdverse) => {
        this.setState({ eventAdverse: eventAdverse });
    }

    handlerDescription = (description) => {
        this.setState({ description: description });
    }

    handlerDateTeam = (date) => {
        this.setState({ dateTeam: date });
    }

    handlerDateEvent = (dateEvent) => {
        this.setState({ dateEvent: dateEvent })
    }

    handlerRelationResearch = (relationResearch) => {
        this.setState({ relationResearch: relationResearch });
    }

    handlerRelationStuty = (relationStuty) => {
        this.setState({ relationStuty: relationStuty });
    }

    handlerClasification = (clasification) => {
        this.setState({ clasification: clasification });
    }

    handlerCausality = (causality) => {
        this.setState({ causality: causality });
    }

    handlerTypeReport = (typeReport) => {
        this.setState({ typeReport: typeReport });
    }

    handlerIntensity = (intensity) => {
        this.setState({ intensity: intensity });
    }

    handlerActionResearch = (actionResearch) => {
        this.setState({ actionResearch: actionResearch });
    }

    handlerCiego = (ciego) => {
        this.setState({ ciego: ciego });
    }

    handlerBrazo = (brazo) => {
        this.setState({ brazo: brazo });
    }

    handlerContinuity = (continuity) => {
        this.setState({ continuity: continuity });
    }

    searchCIE = (name, code) => {

        var data = {
            codigo: code.toUpperCase(),
            nombre: name
        };

        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'cie10/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            }).then(response => {
                return response.json();
            }).then(data => {

                if (data.existe) {
                    resolve(data.contenido);
                } else {
                    resolve([]);
                }
            }).catch((error) => {
                console.error('Error:', error);
                resolve(error);
            });
        })
    };

    validate = () => {

        let errors = {};
        let error = false;

        if (this.state.description === "") {
            error = true;
            errors.description = "Ingresa la descripcion";
        } else {
            errors.description = "";
        }

        if (this.state.diagnostic.length === 0) {
            error = true;
            errors.diagnostic = "Ingresa el diagnostico";
        } else {
            errors.diagnostic = "";
        }

        if (this.state.relationResearch === "") {
            error = true;
            errors.relationResearch = "Ingresa la Relacion con el producto de investigacion";
        } else {
            errors.relationResearch = "";
        }

        if (this.state.relationStuty === "") {
            error = true;
            errors.relationStuty = "Ingresa la Relacion con el procedimiento de estudio";
        } else {
            errors.relationStuty = "";
        }

        if (this.state.clasification === "") {
            error = true;
            errors.clasification = "Ingresa la clasificación";
        } else {
            errors.clasification = "";
        }

        if (this.state.causality === "") {
            error = true;
            errors.causality = "Ingresa la causalidad del evento";
        } else {
            errors.causality = "";
        }

        if (this.state.typeReport === "") {
            error = true;
            errors.typeReport = "Ingresa el tipo de reporte";
        } else {
            errors.typeReport = "";
        }

        if (this.state.continuity === "") {
            error = true;
            errors.continuity = "Ingresa si el evento continua presente";
        } else {
            errors.continuity = "";
        }

        if (this.state.intensity === "") {
            error = true;
            errors.intensity = "Ingresa la intensidad del evento";
        } else {
            errors.intensity = "";
        }

        if (this.state.intensity === "") {
            error = true;
            errors.intensity = "Ingresa la intensidad del evento";
        } else {
            errors.intensity = "";
        }

        if (this.state.actionResearch === "") {
            error = true;
            errors.actionResearch = "Ingresa la accion tomada";
        } else {
            errors.actionResearch = "";
        }

        if (this.state.ciego === "") {
            error = true;
            errors.ciego = "Ingresa la apertura CIEGO";
        } else {
            errors.ciego = "";
        }

        if (this.state.brazo === "") {
            error = true;
            errors.brazo = "Ingresa el brazo";
        } else {
            errors.brazo = "";
        }

        this.setState({ errors: errors });
        return error;

    }

    sendData = () => {


        if (!this.validate()) {

            const sendData = {
                id_historia: this.props.id_historia,
                evento_adverso: this.state.eventAdverse,
                descripcion: this.state.description,
                diagnostico: this.state.diagnostic,
                relacion_investigacion: this.state.relationResearch,
                relacion_estudio: this.state.relationStuty,
                clasificacion: this.state.clasification,
                fecha_conocimiento: moment(this.state.dateTeam).format("YYYY/MM/DD"),
                causalidad: this.state.causality,
                tipo_reporte: this.state.typeReport,
                fecha_inicio: moment(this.state.dateEvent).format("YYYY/MM/DD"),
                evento_continua: this.state.continuity,
                intensidad: this.state.intensity,
                accion_producto: this.state.actionResearch,
                apertura_ciego: this.state.ciego,
                brazo: this.state.brazo,

            };

            console.log(sendData);

            fetch(process.env.REACT_APP_PUBLIC_URL + 'evento-adverso/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(sendData)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);

                }).catch((e) => {
                    console.log(e);
                });
        } else {
            this.setState({
                openAlert: true,
                modalAlert: {
                    message: 'Ingresa los datos Correctamente',
                    color: 'danger',
                    title: "Error!"
                }
            });
        }
    }

    render() {

        const reactTableFoundDiagnostics = {
            tableHeaderData: [{
                Header: 'Codigo',
                accessor: 'codigo',
                disableGlobalFilter: true,
                width: 65,
            },
            {
                Header: 'Nombre',
                accessor: 'nombre',
            },
            ],
            tableRowsData: this.state.dataDiagnostic
        };

        return (
            <Col>
                <Card body outline color="secondary">
                    <div className="form" style={{ display: "flex", flexDirection: "column" }}>
                        <div className="card__title">
                            <h5 className="bold-text">Eventos Adversos</h5>
                        </div>
                        <div style={{ width: '80%' }}>
                            <div style={{ width: 350 }}>
                                <span className="form__form-group-label">Evento Adverso</span>
                                <div className="form__form-group-field">
                                    <label
                                        className="radio-btn"
                                    >
                                        <input
                                            className="radio-btn__radio"
                                            name="event-adverse"
                                            id="event-adverse"
                                            type="radio"
                                            value={'Si'}
                                            onChange={(e) => {
                                                //console.log(e.target);
                                                this.handlerEventAdverse(e.target.value);
                                            }}
                                        />
                                        <span className="radio-btn__radio-custom" />
                                        <span className="radio-btn__label">{"Sí"}</span>
                                    </label>
                                    <label
                                        className="radio-btn"
                                    >
                                        <input
                                            className="radio-btn__radio"
                                            name="event-adverse"
                                            id="event-adverse"
                                            type="radio"
                                            value={'No'}
                                            onChange={(e) => {
                                                this.handlerEventAdverse(e.target.value);
                                            }}
                                        />
                                        <span className="radio-btn__radio-custom" />
                                        <span className="radio-btn__label">{"No"}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {this.state.eventAdverse === 'Si' ?

                            <Fragment>
                                <div style={{ display: 'flex', marginTop: 40, }}>
                                    <div style={{ marginRight: 20 }} >
                                        <span className="form__form-group-label">Descripción</span>
                                    </div>
                                    <div className="form__form-group-field">
                                        <Field
                                            name="textarea-desc"
                                            component="textarea"
                                            type="text"
                                            style={{ width: '90%' }}
                                            onChange={(e) => {
                                                this.handlerDescription(e.target.value);
                                            }}
                                        />
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("description") ? this.state.errors.description : ""}
                                        </span>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', marginTop: 50, }}>
                                    <div style={{ marginRight: 20 }} >
                                        <span className="form__form-group-label">Diagnostico</span>
                                    </div>
                                    <Button
                                        outline
                                        onClick={() => {

                                            this.setState({ openModal: true });
                                        }}
                                    >
                                        <span className="lnr lnr-magnifier" style={{ fontSize: 20 }} />
                                    </Button>
                                    <TextField
                                        type="text"
                                        className="material-form__field"
                                        disabled
                                        style={{ width: 120, marginRight: 20 }}
                                        value={typeof this.state.diagnostic.codigo !== 'undefined' ? this.state.diagnostic.codigo : ""}
                                    />
                                    <TextField
                                        type="text"
                                        className="material-form__field"
                                        disabled
                                        style={{ width: '70%' }}
                                        value={typeof this.state.diagnostic.nombre !== 'undefined' ? this.state.diagnostic.nombre : ""}
                                    />
                                    <span className="form__form-group-label" style={{ color: "red" }}>
                                        {this.state.errors.hasOwnProperty("diagnostic") ? this.state.errors.diagnostic : ""}
                                    </span>
                                </div>
                                <div style={{ display: 'flex', marginTop: 50, }}>

                                    <div style={{ marginRight: 20, width: '25%' }} >
                                        <span className="form__form-group-label" > Relación con el producto de investigación </span>
                                    </div>
                                    <div className="form__form-group-field">
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="product"
                                                type="radio"
                                                value={'Si'}
                                                onChange={(e) => {
                                                    //console.log(e.target);
                                                    this.handlerRelationResearch(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Sí"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="product"
                                                type="radio"
                                                value={'No'}
                                                onChange={(e) => {
                                                    this.handlerRelationResearch(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"No"}</span>
                                        </label>
                                        <div className="form__form-group" >
                                            <div className="form__form-group-field" >
                                                <input
                                                    name="product-text"
                                                    component={renderField}
                                                    type="text"
                                                    style={{ width: '50%', marginTop: 10 }}
                                                    onChange={(e) => {

                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("relationResearch") ? this.state.errors.relationResearch : ""}
                                        </span>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', marginTop: 50, }}>

                                    <div style={{ marginRight: 20, width: '25%' }} >
                                        <span className="form__form-group-label" > Relación con el procedimiento del estudio </span>
                                    </div>
                                    <div className="form__form-group-field">
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="study"
                                                type="radio"
                                                value={'Si'}
                                                onChange={(e) => {
                                                    //console.log(e.target);
                                                    this.handlerRelationStuty(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Sí"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="study"
                                                type="radio"
                                                value={'No'}
                                                onChange={(e) => {
                                                    this.handlerRelationStuty(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"No"}</span>
                                        </label>
                                        <div className="form__form-group" >
                                            <div className="form__form-group-field" >
                                                <input
                                                    name="product-text"
                                                    component={renderField}
                                                    type="text"
                                                    style={{ width: '50%', marginTop: 10 }}
                                                    onChange={(e) => {

                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("relationStuty") ? this.state.errors.relationStuty : ""}
                                        </span>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', marginTop: 50, }}>

                                    <div style={{ marginRight: 20, }} >
                                        <span className="form__form-group-label">Clasificación </span>
                                    </div>
                                    <div className="form__form-group-field" style={{ marginLeft: 20 }}>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="clasificacion"
                                                type="radio"
                                                value={'No Serio'}
                                                onChange={(e) => {
                                                    //console.log(e.target);
                                                    this.handlerClasification(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"No Serio"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="clasificacion"
                                                type="radio"
                                                value={'Serio'}
                                                onChange={(e) => {
                                                    this.handlerClasification(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Serio"}</span>
                                        </label>
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("clasification") ? this.state.errors.clasification : ""}
                                        </span>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', marginTop: 50, }}>

                                    <div style={{ marginRight: 20, }} >
                                        <span className="form__form-group-label">Fecha de conocimiento por el equipo investigador </span>
                                    </div>
                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                        <DatePicker
                                            views={["year", "month", "date"]}
                                            value={this.state.dateTeam}
                                            className="material-form__field"
                                            style={{ width: 200, marginLeft: 20 }}
                                            onChange={(date) => {
                                                //this.handlerBirthDate(new Date(date));
                                                this.handlerDateTeam(date);
                                            }}
                                            animateYearScrolling
                                            format="yyyy/MM/D"
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                <div style={{ display: 'flex', marginTop: 50, }}>
                                    <div style={{ marginRight: 20, }} >
                                        <span className="form__form-group-label"> Causalidad del Evento </span>
                                    </div>
                                    <div style={{ width: '20%' }}>
                                        <Field
                                            className="cause-of-admission"
                                            name="cause-of-admission"
                                            component={renderSelectField}
                                            options={[
                                                { value: '1', label: 'ninguno' },
                                            ]}
                                            onChange={(e) => {
                                                this.handlerCausality(e.value);
                                            }}
                                        />
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("causality") ? this.state.errors.causality : ""}
                                        </span>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', marginTop: 50, }}>

                                    <div style={{ marginRight: 20, width: '13%' }} >
                                        <span className="form__form-group-label">Tipo de Reporte </span>
                                    </div>
                                    <div className="form__form-group-field" style={{ marginLeft: 20, }}>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="type"
                                                type="radio"
                                                value={'Inicial'}
                                                onChange={(e) => {
                                                    //console.log(e.target);
                                                    this.handlerTypeReport(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Inicial"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="type"
                                                type="radio"
                                                value={'Seguimiento'}
                                                onChange={(e) => {
                                                    this.handlerTypeReport(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Seguimiento"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="type"
                                                type="radio"
                                                value={'Final'}
                                                onChange={(e) => {
                                                    this.handlerTypeReport(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Final"}</span>
                                        </label>
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("typeReport") ? this.state.errors.typeReport : ""}
                                        </span>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', marginTop: 50, }}>
                                    <div style={{ marginRight: 20, }} >
                                        <span className="form__form-group-label">Fecha Inicio del Evento </span>
                                    </div>
                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                        <DatePicker
                                            views={["year", "month", "date"]}
                                            className="material-form__field"
                                            value={this.state.dateEvent}
                                            style={{ width: 200, marginLeft: 20 }}
                                            onChange={(date) => {
                                                //this.handlerBirthDate(new Date(date));
                                                this.handlerDateEvent(date);

                                            }}
                                            animateYearScrolling
                                            format="yyyy/MM/D"
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>

                                <div style={{ display: 'flex', marginTop: 50, }}>
                                    <div style={{ marginRight: 20, width: '13%' }} >
                                        <span className="form__form-group-label"> Evento Continua Presente </span>
                                    </div>
                                    <div className="form__form-group-field">
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="event-continue"
                                                type="radio"
                                                value={'Si'}
                                                onChange={(e) => {
                                                    //console.log(e.target);
                                                    this.handlerContinuity(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Sí"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="event-continue"
                                                type="radio"
                                                value={'No'}
                                                onChange={(e) => {
                                                    this.handlerContinuity(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"No"}</span>
                                        </label>
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("continuity") ? this.state.errors.continuity : ""}
                                        </span>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', marginTop: 50, }}>

                                    <div style={{ marginRight: 20, width: '13%' }} >
                                        <span className="form__form-group-label">Intensidad </span>
                                    </div>
                                    <div className="form__form-group-field" style={{ marginLeft: 20, }}>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="intensity"
                                                type="radio"
                                                value={'leve'}
                                                onChange={(e) => {
                                                    //console.log(e.target);
                                                    this.handlerIntensity(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Leve"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="intensity"
                                                type="radio"
                                                value={'Moderado'}
                                                onChange={(e) => {
                                                    this.handlerIntensity(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Moderado"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="intensity"
                                                type="radio"
                                                value={'Severo'}
                                                onChange={(e) => {
                                                    this.handlerIntensity(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Severo"}</span>
                                        </label>
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("intensity") ? this.state.errors.intensity : ""}
                                        </span>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', marginTop: 50, }}>

                                    <div style={{ marginRight: 20, width: '25%' }} >
                                        <span className="form__form-group-label">Acción tomada con el producto de investigación </span>
                                    </div>
                                    <div className="form__form-group-field" style={{ marginLeft: 20, flexDirection: 'column' }}>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="action"
                                                type="radio"
                                                value={'Suspensión definitiva de la molecula de investigación'}
                                                onChange={(e) => {
                                                    //console.log(e.target);
                                                    this.handlerActionResearch(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Suspensión definitiva de la molecula de investigación"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="action"
                                                type="radio"
                                                value={'Suspensión temporal de la molecula de investigación'}
                                                onChange={(e) => {
                                                    this.handlerActionResearch(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Suspensión temporal de la molecula de investigación"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="action"
                                                type="radio"
                                                value={'Continua con molecula de investigación'}
                                                onChange={(e) => {
                                                    this.handlerActionResearch(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Continua con molecula de investigación"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="action"
                                                type="radio"
                                                value={'Completó tratamiento / sin producto de investigacion'}
                                                onChange={(e) => {
                                                    this.handlerActionResearch(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Completó tratamiento / sin producto de investigacion"}</span>
                                        </label>
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("actionResearch") ? this.state.errors.actionResearch : ""}
                                        </span>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', marginTop: 50, }}>

                                    <div style={{ marginRight: 20, width: '13%' }} >
                                        <span className="form__form-group-label"> Requirió apertura de CIEGO </span>
                                    </div>
                                    <div className="form__form-group-field">
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="ciego"
                                                type="radio"
                                                value={'Si'}
                                                onChange={(e) => {
                                                    //console.log(e.target);
                                                    this.handlerCiego(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Sí"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="ciego"
                                                type="radio"
                                                value={'No'}
                                                onChange={(e) => {
                                                    this.handlerCiego(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"No"}</span>
                                        </label>
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("ciego") ? this.state.errors.ciego : ""}
                                        </span>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', marginTop: 50, }}>
                                    <div style={{ width: 150 }}>
                                        <div style={{ marginRight: 10, width: '100%' }} >
                                            <span className="form__form-group-label"> ¿Cuál es el brazo? </span>
                                        </div>
                                    </div>

                                    <div className="form__form-group" >
                                        <div className="form__form-group-field" >
                                            <input
                                                name="product-text"
                                                component={renderField}
                                                type="text"
                                                style={{ width: '40%', marginTop: 10 }}
                                                onChange={(e) => {
                                                    this.handlerBrazo(e.target.value);
                                                }}
                                            />
                                        </div>
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("brazo") ? this.state.errors.brazo : ""}
                                        </span>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', marginTop: 40, }}>

                                    <Button style={{ marginLeft: 60, marginTop: 20 }} size="sm" color="primary"
                                        onClick={() => {
                                            this.sendData();
                                        }}
                                    >Guardar</Button>
                                </div>

                                {this.state.openAlert ?
                                    <ModalMessage
                                        color={this.state.modalAlert.color}
                                        title={this.state.modalAlert.title}
                                        message={this.state.modalAlert.message}
                                        modal={this.state.openAlert}
                                        toggle={() => { this.setState({ openAlert: !this.state.openAlert }) }}
                                        onOk={() => { this.setState({ openAlert: !this.state.openAlert }) }}
                                    /> : null}

                                <Modal
                                    open={this.state.openModal}
                                    onClose={() => {
                                        this.setState({ openModal: false });
                                    }}
                                    aria-labelledby="simple-modal-title"
                                    aria-describedby="simple-modal-description"
                                    style={{ zIndex: 1000 }}
                                >
                                    <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                                        <div>
                                            <h5 className="bold-text">Diagnostico</h5>
                                        </div>
                                        <div className="form">
                                            <div style={{ display: 'flex', width: '100%' }}>
                                                <div className="form__form-group" style={{ marginRight: 10 }}>
                                                    <span className="form__form-group-label">CIE 10</span>
                                                    <div className="form__form-group-field">
                                                        <Field
                                                            name="search-cups"
                                                            component="input"
                                                            type="text"
                                                            placeholder="Codigo"
                                                            onChange={(e) => {
                                                                console.log(e.target.value);
                                                                this.setState({ load: true }, () => {
                                                                    this.searchCIE("", e.target.value).then((dataDiagnostic) => {
                                                                        this.setState({ dataDiagnostic: dataDiagnostic, load: false });
                                                                    });
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form__form-group">
                                                    <span className="form__form-group-label">Nombre</span>
                                                    <div className="form__form-group-field">
                                                        <input
                                                            name="search-diagnostic"
                                                            type="text"
                                                            placeholder="Diagnostico"
                                                            onChange={(e) => {
                                                                var diagnostic = e.target.value;
                                                                this.setState({ load: true }, () => {
                                                                    console.log(diagnostic)
                                                                    this.searchCIE(diagnostic, "").then((dataDiagnostic) => {
                                                                        this.setState({ dataDiagnostic: dataDiagnostic, load: false });
                                                                    });
                                                                });
                                                            }}
                                                        >
                                                        </input>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                            {!this.state.load ?
                                                <DataReactTable
                                                    title=""
                                                    reactTableData={reactTableFoundDiagnostics}
                                                    config={{
                                                        withPagination: true,
                                                        withSearchEngine: false,
                                                        isSortable: false,
                                                        watchCustomMenu: false
                                                    }}
                                                    ReactTableActions={ReactTableActionsDiagnostic}
                                                    Callback={(diagnostic) => {
                                                        //console.log(diagnostic);
                                                        this.setState({ diagnostic: diagnostic, openModal: false });
                                                    }}
                                                /> : <div style={{ margin: 'auto', width: 270, height: 420 }}>
                                                    <div class="load__icon-wrap">
                                                        <svg class="load__icon">
                                                            <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                                                        </svg>
                                                    </div>
                                                </div>}
                                            {!this.state.load && this.state.dataDiagnostic.length === 0 ?
                                                <div style={{ margin: 'auto', width: 270, height: 420 }}>
                                                    No hay elementos que mostrar
                                                </div>
                                                : null}
                                        </div>
                                    </div>
                                </Modal>

                            </Fragment>
                            : null}
                    </div>
                </Card>
            </Col>
        );
    }

}

export default reduxForm({
    form: `event-adverse-form`, // a unique identifier for this form
})(withTranslation('common')(EventAdverse));
